import React, { PureComponent } from 'react'
import { VerticalDots, InfoIcon } from '../../../assets'

export const MCCategoryNameComponent = (props) => {
  const { value, data } = props

  const verticalImageClick = (e) => {
    props.menuEvent(e, props.data)
  }

  const checkBoxClick = (e) => {
    props.checkEvent(e, props.data)
  }

  const numChildren = data.children && data.children.length
  const isParent = !!data.children
  const shop = (data.shop && data.shop.name) || ''
  const shopActive = data.shop && data.shop.active && !data.shop.deleted
  return (
    <div className="container-category-name">
      <img
        className="vertical-dots"
        src={`${VerticalDots}`}
        onClick={(e) => verticalImageClick(e)}
      />

      {isParent ? (
        <div>
          {value}
          <span style={{ fontWeight: 'bold', marginLeft: '4px' }}>({numChildren})</span>
        </div>
      ) : null}
      {shop ? (
        <div class="vertical-shop-name">
          {value}
          <span style={{ fontWeight: 'bold' }}>
            ({shop}) {!shopActive ? '(Inactive)' : ''}
          </span>
        </div>
      ) : null}
    </div>
  )
}

export default MCCategoryNameComponent



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/MCCategoryNameComponent.js